import axiosSso from "@/api/interceptor_sso";

// 开户
export function postUserClients(data: any) {
  return axiosSso.post(`/agent/clients`, data);
}

// 查看
export function getUserClientsID(params: any, id: any) {
  return axiosSso.get(`/agent/clients/${id}`, { params });
}

// 编辑
export function putUserClients(data: any) {
  return axiosSso.put(`/agent/clients/${data.id}`, data);
}

// 重置密码
export function putClientRestsPwd(data: any) {
  return axiosSso.put(`/agent/clients/${data.id}/reset-password`, data);
}

/**
 * 查看初始密码
 * @param id
 * @param params
 */
export function getAgentClientsPassword(id: any, params: any) {
  return axiosSso.get(`/agent/clients/${id}/password`, params);
}
